import { render } from "./ProjectHeader.vue?vue&type=template&id=f1ed0c62"
import script from "./ProjectHeader.vue?vue&type=script&lang=js"
export * from "./ProjectHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__